// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"434":"224e0892","533":"224e0892","668":"224e0892"}[chunkId] + ".chunk.css";
};